import HttpClient from "./HttpClient";
import {
  API_AUTOCOMPLETE_CMR,
  API_CASHBOX_OPERATE,
  API_CHANGE_PASSWORD_URL,
  API_CLEAR_DELETED_DECLARANTS_TABLE,
  API_CREATE_CMR,
  API_CREATE_DECLARANTS,
  API_DECLARANTS_BY_USER_DEPARTMENT_GROUPED_URL,
  API_DELETE_DECLARANT_URL,
  API_DOWNLOAD_XML,
  API_FORCE_DELETE_DECLARANT,
  API_GET_CLIENTS,
  API_GET_CLIENTS_FEE,
  API_GET_CLIENTS_WITH_RATES,
  API_GET_CMR,
  API_GET_COUNTRIES,
  API_GET_CREATORS,
  API_GET_DECLARANTS_BY_USERS_URL,
  API_GET_DECLARANTS_GROUPED_BY_CLIENTS,
  API_GET_DECLARANTS_URL,
  API_GET_SIGMA_URL,
  API_GET_DELETED_DECLARANTS,
  API_GET_DEPARTMENTS,
  API_GET_SERVICES,
  API_GET_USER_URL,
  API_GROUP_DECLARANTS,
  API_IMPORT_DECLARANTS,
  API_LAST_ENCASHMENT_ACTION,
  API_LOGIN_URL,
  API_LOGOUT_URL,
  API_RESTORE_DECLARANT,
  API_SAVE_USER_SETTING,
  API_UPDATE_CMR,
  API_UPDATE_DECLARANTS_DEPARTMENT_DATA,
  API_UPDATE_DECLARANTS_URL,
  API_UPDATE_GROUP_DECLARANTS,
  API_GET_DECLARANT_INVOICE_TYPES,
  API_URL,
  ATTACH_DECLARANT_TO_CUSTOM_GROUP,
  CMR_LIST,
  COPY_TO_NEW_CMR,
  DELETE_CMR,
  DOWNLOAD_CMRS_PDF,
  GET_CMR_NUMBER,
  GET_LATEST_DEPARTMENT_DATES,
  GROUP_DECLARANTS_BY_CLIENT,
  LOAD_CASHBOX_DATA_BY_DECLARANT,
  LOAD_DEPARTMENT_DATA_SUMMARY,
  RESET_PASSWORD_URL,
  SEND_RESET_PASSWORD_REQUEST,
  API_GET_CLIENTS_WITH_NO_CLIENTS,
  DOWNLOAD_EXCEL_FILE,
  API_UPDATE_CUSTOM_GROUP_ATTRIBUTES,
  API_DOWNLOAD_CUSTOM_EXCEL_FILE_URL,
  API_GET_LOGISTIC_LIST,
  API_SAVE_LOGISTIC_ENTITY,
  API_UPDATE_LOGISTIC_ENTITY,
  API_DELETE_LOGISTIC_ENTITY,
  GET_SEARCH_FIELD_VALUES,
  API_SAVE_LOGISTIC_DOCUMENTS,
  API_DOWNLOAD_LOGISTIC_DOCUMENT,
  API_DELETE_LOGISTIC_DOCUMENT,
  DOWNLOAD_DECLARANT_TABLE_DATA_AS_EXCEL_FILE,
  DOWNLOAD_LOGISTIC_TABLE_DATA_AS_EXCEL_FILE,
  API_DELETE_CONTRACTS_ENTITY,
  API_SAVE_CONTRACTS_ENTITY,
  API_SAVE_CONTRACTS_DOCUMENTS,
  API_UPDATE_CONTRACTS_ENTITY,
  API_DOWNLOAD_CONTRACTS_DOCUMENT,
  API_DELETE_CONTRACTS_DOCUMENT,
  API_GET_CONTRACTS_LIST,
  GET_CONTRACTS_SEARCH_FIELD_VALUES,
  DOWNLOAD_CONTRACTS_TABLE_DATA_AS_EXCEL_FILE,
  STATUS_OPTIONS,
  API_DECLARANTS_INVOICE,
  API_GET_FLEET_EXPENSES_TRANSPORTS,
  API_GET_FLEET_EXPENSES_SPENDING_TYPES,
  API_GET_FLEET_DRIVERS,
  API_GET_FLEET_DRIVER_CARD_ASSIGNMENTS,
  API_FLEET_EXPENSE,
  API_DECLARANTS_REGISTER_OF_ACCOUNTS,
  API_DECLARANT_TWS_SYNC,
  API_DECLARANT_TWS_SYNC_BY_ID,
  API_ASSIGN_CLIENT_TO_DECLARANTS,
} from "../constants/api";
import {
  getToken,
  removeCurrentSession,
  setUserSession,
} from "../helpers/auth";
import { LoginResponse } from "./responses";
import { IObjectMap } from "../interfaces/common";
import ee from "./EventEmitter";
import { UNAUTHORIZED_ACTION } from "../constants/events";
import loadDeclarantsNormaliser from "../normalizer/loadDeclarants";
import createDeclarantNormaliser from "../normalizer/createDeclarant";
import createCmrNormaliser from "../normalizer/createCmr";
import { IDS } from "../constants/queryParameters";
import { Parameters } from "../interfaces/parameters";
import normalize from "../normalizer/baseNormalizer";
import { DownloadFileParameters } from "stores/LogisticStore";
import { CreateFleetExpensesTransportParameters } from "../models/FleetExpenses/FleetExpensesTransport";
import {
  FleetDriver,
  FleetExpenseParameters,
  FleetExpenseId,
} from "../models/FleetExpenses/FleetExpensesModel";
import { Declarant, DeclarantId } from "../models/Declarant";
import { DeclarantTwsSyncRequest } from "../models/DeclarantTwsSync";

type ResponsePromise = Promise<Response>;

export interface IManager {
  login(email: string, password: string): Promise<LoginResponse>;

  logout(): ResponsePromise;

  getCurrentUser(): ResponsePromise | null;

  saveSettings(params: Object): ResponsePromise;

  createDeclarant(params: Object): ResponsePromise;

  declarantTwsSync(params: DeclarantTwsSyncRequest): ResponsePromise;

  declarantExistingTwsSync(params: DeclarantTwsSyncRequest): ResponsePromise;

  singleDeclarantTwsSync(id: DeclarantId): ResponsePromise;

  getClients(): ResponsePromise;

  getClientsWithNoClients(): ResponsePromise;

  getClientsWithRates(): ResponsePromise;

  calculateClientsFee(parameters?: Record<string, unknown>): ResponsePromise;

  getCreators(): ResponsePromise;

  getDepartments(): ResponsePromise;

  getLatestDepartmentDates(): ResponsePromise;

  getDeclarants(params: Object): ResponsePromise;

  getSigma(params: Object): ResponsePromise;

  getDeclarantsByUsers(params: Object): ResponsePromise;

  sendImportFile(formData: FormData): ResponsePromise;

  updateDeclarant(id: unknown, params: Object): ResponsePromise;

  assignClientToDeclarants(
    declarantIds: DeclarantId[],
    clientId: number
  ): ResponsePromise;

  updateDepartmentDataByDeclarant(id: unknown, params: Object): ResponsePromise;

  updateCustomGroupField(id: unknown, params: Object): ResponsePromise;

  loadByUserDepartment(parameters?: IObjectMap): ResponsePromise;

  loadDeclarantsByClients(parameters?: IObjectMap): ResponsePromise;

  deleteDeclarant(id: unknown): ResponsePromise;

  sendDownloadRequest(ids: (string | number)[]): ResponsePromise;

  downloadExcelFile(parameters: Object): ResponsePromise;

  downloadCustomExcelFile(parameters: Object): ResponsePromise;

  clearDeclarants(): ResponsePromise;

  restoreDeclarant(id: unknown): ResponsePromise;

  forceDeleteDeclarant(id: unknown): ResponsePromise;

  loadDeletedEntities(parameters?: IObjectMap): ResponsePromise;

  sendResetPasswordRequest(parameters: Object): ResponsePromise;

  resetPassword(params: Object): ResponsePromise;

  changePassword(parameters: Object): ResponsePromise;

  groupDeclarants(
    clientId: unknown,
    declarantsIds: (string | number)[]
  ): ResponsePromise;

  loadDepartmentDataSummary(parameters: IObjectMap): ResponsePromise;

  getDeclarantInvoiceTypes(): ResponsePromise;

  loadGroupBy(parameters: IObjectMap): ResponsePromise;

  ungroupDeclarants(
    clientId: unknown,
    $ids: (string | number)[]
  ): ResponsePromise;

  updateFieldsInCustomGroup(
    groupId: unknown,
    attributes: Object
  ): ResponsePromise;

  operateCash(parameters: IObjectMap): ResponsePromise;

  getLastEncashmentAction(departmentId: unknown): ResponsePromise;

  loadCashboxItems(
    declarantId: unknown,
    parameters: IObjectMap
  ): ResponsePromise;

  getCmrs(parameters: Object): ResponsePromise;

  getCountries(): ResponsePromise;

  getServices(): ResponsePromise;

  createCmr(params: Object): ResponsePromise;

  getCmr(id: unknown): ResponsePromise;

  updateCmr(id: unknown, params: Object): ResponsePromise;

  deleteCmr(id: number): ResponsePromise;

  downloadCmrsPdf(id: number): ResponsePromise;

  attachDeclarantToCustomEntities(
    customGroupId: unknown,
    declarants: Declarant[]
  ): ResponsePromise;

  getCmrNumber(): ResponsePromise;

  copyToNew(id: unknown): ResponsePromise;

  cmrAutocomplete(fieldName: string, value: string | number): ResponsePromise;

  loadLogisticByClients(parameters?: IObjectMap): ResponsePromise;

  loadFleetExpensesByClients(parameters?: IObjectMap): ResponsePromise;

  loadFleetExpensesTransports(parameters?: IObjectMap): ResponsePromise;

  loadFleetExpensesSpendingTypes(parameters?: IObjectMap): ResponsePromise;

  loadFleetDrivers(): ResponsePromise;

  loadFleetDriverCardAssignments(
    driverId: FleetDriver["id"],
    date: string
  ): ResponsePromise;

  createFleetExpensesTransport(
    params: CreateFleetExpensesTransportParameters
  ): ResponsePromise;

  createFleetExpense(params: FleetExpenseParameters): ResponsePromise;

  updateFleetExpense(
    id: FleetExpenseId,
    params: FleetExpenseParameters
  ): ResponsePromise;

  deleteFleetExpense(id: FleetExpenseId): ResponsePromise;

  saveLogisticEntity(parameters?: IObjectMap): ResponsePromise;

  updateLogisticEntity(id: unknown, params: Object): ResponsePromise;

  deleteLogisticEntity(id: unknown): ResponsePromise;

  getSearchFieldValues(field: string): ResponsePromise;

  saveLogisticDocuments(formData: FormData): ResponsePromise;

  downloadFile(parameters?: IObjectMap): ResponsePromise;

  deleteLogisticFile(parameters?: DownloadFileParameters): ResponsePromise;

  downloadDeclarantAsExcelFile(parameters: Object): ResponsePromise;

  downloadLogisticAsExcelFile(parameters: Object): ResponsePromise;

  deleteContractsEntity(id: unknown): ResponsePromise;

  saveContractsEntity(parameters?: IObjectMap): ResponsePromise;

  saveContractsDocuments(formData: FormData): ResponsePromise;

  updateContractsEntity(id: unknown, params: Object): ResponsePromise;

  downloadContractsFile(parameters?: IObjectMap): ResponsePromise;

  deleteContractsFile(parameters?: DownloadFileParameters): ResponsePromise;

  loadContractsByClients(parameters?: IObjectMap): ResponsePromise;

  getContractsSearchFieldValues(field: string): ResponsePromise;

  downloadContractsAsExcelFile(parameters: Object): ResponsePromise;

  getStatusOptions(): ResponsePromise;

  generateInvoice(parameters: Object): ResponsePromise;

  generateRegisterOfAccounts(payload: {
    date_from: string;
    date_to: string;
    groups: object[];
  }): ResponsePromise;

  downloadInvoice(key: number, type?: string): ResponsePromise;
}

class Manager implements IManager {
  private client: HttpClient;

  private readonly defaultHeaders: Headers;

  constructor() {
    this.defaultHeaders = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
    });

    const token = getToken();

    if (token) {
      this.defaultHeaders.append("Authorization", token);
    }

    this.client = new HttpClient(API_URL, this.defaultHeaders);
  }

  login(email: string, password: string): Promise<LoginResponse> {
    return this.client
      .post(API_LOGIN_URL, {
        email,
        password,
      })
      .then(async (response) => {
        const data = (await response.json()) as LoginResponse;

        if (response.ok && data.access_token && data.token_type) {
          this.defaultHeaders.append(
            "Authorization",
            `${data.token_type} ${data.access_token}`
          );

          setUserSession(data.access_token, data.token_type);
        }

        return data;
      });
  }

  logout(): ResponsePromise {
    return this.client.post(API_LOGOUT_URL).then((response) => {
      removeCurrentSession();

      return response;
    });
  }

  getCurrentUser(): ResponsePromise | null {
    const token = getToken();

    if (token) {
      const promise = this.client.post(API_GET_USER_URL).then((response) => {
        return response;
      });

      return this.checkPromise(promise);
    }

    return null;
  }

  saveSettings(params: Object): ResponsePromise {
    const promise = this.client.put(API_SAVE_USER_SETTING, params);

    return this.checkPromise(promise);
  }

  // declarants

  createDeclarant(params: Object): ResponsePromise {
    const promise = this.client.post(
      API_CREATE_DECLARANTS,
      createDeclarantNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  declarantTwsSync(params: DeclarantTwsSyncRequest): ResponsePromise {
    const promise = this.client.post(API_DECLARANT_TWS_SYNC, params);

    return this.checkPromise(promise);
  }

  declarantExistingTwsSync(params: DeclarantTwsSyncRequest): ResponsePromise {
    const promise: ResponsePromise = this.declarantTwsSync({
      ...params,
      with_rewrite: true,
    });

    return this.checkPromise(promise);
  }

  singleDeclarantTwsSync(id: DeclarantId): ResponsePromise {
    const promise = this.client.post(API_DECLARANT_TWS_SYNC_BY_ID(id));

    return this.checkPromise(promise);
  }

  getDeclarants(params: Parameters): ResponsePromise {
    const promise = this.client.get(
      API_GET_DECLARANTS_URL,
      loadDeclarantsNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  getSigma(params: Parameters): ResponsePromise {
    const promise = this.client.get(
      API_GET_SIGMA_URL,
      loadDeclarantsNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  getDeclarantsByUsers(params: Parameters): ResponsePromise {
    const promise = this.client.get(
      API_GET_DECLARANTS_BY_USERS_URL,
      loadDeclarantsNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  sendImportFile(formData: FormData): ResponsePromise {
    this.defaultHeaders.delete("Content-Type");

    const promise = this.client.post(API_IMPORT_DECLARANTS, formData);

    this.defaultHeaders.append("Content-Type", "application/json");

    return this.checkPromise(promise);
  }

  updateDeclarant(id: unknown, params: Object): ResponsePromise {
    const promise = this.client.put(API_UPDATE_DECLARANTS_URL(id), params);

    return this.checkPromise(promise);
  }

  assignClientToDeclarants(
    declarantIds: DeclarantId[],
    clientId: number
  ): ResponsePromise {
    const promise = this.client.put(API_ASSIGN_CLIENT_TO_DECLARANTS, {
      declarant_ids: declarantIds,
      client_id: clientId,
    });

    return this.checkPromise(promise);
  }

  updateDepartmentDataByDeclarant(
    id: unknown,
    params: Object
  ): ResponsePromise {
    const promise = this.client.put(
      API_UPDATE_DECLARANTS_DEPARTMENT_DATA(id),
      params
    );

    return this.checkPromise(promise);
  }

  deleteDeclarant(id: unknown): ResponsePromise {
    const promise = this.client.delete(API_DELETE_DECLARANT_URL(id));

    return this.checkPromise(promise);
  }

  sendDownloadRequest(ids: (string | number)[]): ResponsePromise {
    const queryParameters = ids.reduce((accumulator, currentValue, index) => {
      if (index < 1) {
        return `${accumulator}${currentValue}`;
      }

      return `${accumulator}&${IDS}[]=${currentValue}`;
    }, `?${IDS}[]=`);

    const promise = this.client.get(`${API_DOWNLOAD_XML}${queryParameters}`);

    return this.checkPromise(promise);
  }

  loadDeletedEntities(parameters?: Object): ResponsePromise {
    const promise = this.client.get(
      API_GET_DELETED_DECLARANTS,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  loadByUserDepartment(parameters?: Object) {
    const promise = this.client.get(
      // without groups request
      // API_DECLARANTS_BY_USER_DEPARTMENT_URL,
      API_DECLARANTS_BY_USER_DEPARTMENT_GROUPED_URL,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  loadDeclarantsByClients(parameters?: Object): ResponsePromise {
    const promise = this.client.get(
      API_GET_DECLARANTS_GROUPED_BY_CLIENTS,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  // end declarants section

  getClients(): ResponsePromise {
    const promise = this.client.get(API_GET_CLIENTS);

    return this.checkPromise(promise);
  }

  getClientsWithNoClients(): ResponsePromise {
    const promise = this.client.get(API_GET_CLIENTS_WITH_NO_CLIENTS);

    return this.checkPromise(promise);
  }

  getClientsWithRates(): ResponsePromise {
    const promise = this.client.get(API_GET_CLIENTS_WITH_RATES);

    return this.checkPromise(promise);
  }

  calculateClientsFee(parameters: Record<string, unknown>): ResponsePromise {
    const promise = this.client.get(API_GET_CLIENTS_FEE, parameters);

    return this.checkPromise(promise);
  }

  getCreators(): ResponsePromise {
    const promise = this.client.get(API_GET_CREATORS);

    return this.checkPromise(promise);
  }

  getDepartments(): ResponsePromise {
    const promise = this.client.get(API_GET_DEPARTMENTS);

    return this.checkPromise(promise);
  }

  private checkPromise = (promise: ResponsePromise) =>
    promise.catch((response) => {
      if (response.status === 401) {
        removeCurrentSession();
        this.defaultHeaders.delete("Authorization");

        ee.emit(UNAUTHORIZED_ACTION, "Unauthorized action");
      }

      throw response;
    });

  clearDeclarants(): ResponsePromise {
    const promise = this.client.delete(API_CLEAR_DELETED_DECLARANTS_TABLE);

    return this.checkPromise(promise);
  }

  restoreDeclarant(id: unknown): ResponsePromise {
    const promise = this.client.post(API_RESTORE_DECLARANT(id));

    return this.checkPromise(promise);
  }

  forceDeleteDeclarant(id: unknown): ResponsePromise {
    const promise = this.client.delete(API_FORCE_DELETE_DECLARANT(id));

    return this.checkPromise(promise);
  }

  sendResetPasswordRequest(parameters: Object): ResponsePromise {
    const promise = this.client.post(SEND_RESET_PASSWORD_REQUEST, parameters);

    return this.checkPromise(promise);
  }

  resetPassword(parameters: Object): ResponsePromise {
    const promise = this.client.post(RESET_PASSWORD_URL, parameters);

    return this.checkPromise(promise);
  }

  changePassword(parameters: Object): ResponsePromise {
    const promise = this.client.put(API_CHANGE_PASSWORD_URL, parameters);

    return this.checkPromise(promise);
  }

  groupDeclarants(
    clientId: unknown,
    declarantsIds: (string | number)[]
  ): ResponsePromise {
    const promise = this.client.post(GROUP_DECLARANTS_BY_CLIENT(clientId), {
      declarants: declarantsIds,
    });

    return this.checkPromise(promise);
  }

  ungroupDeclarants(
    clientId: unknown,
    $ids: (string | number)[]
  ): ResponsePromise {
    const promise = this.client.delete(GROUP_DECLARANTS_BY_CLIENT(clientId), {
      declarants: $ids,
    });

    return this.checkPromise(promise);
  }

  loadDepartmentDataSummary(parameters: Object): ResponsePromise {
    const promise = this.client.get(
      LOAD_DEPARTMENT_DATA_SUMMARY,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  getDeclarantInvoiceTypes(): ResponsePromise {
    const promise: Promise<Response> = this.client.get(
      API_GET_DECLARANT_INVOICE_TYPES
    );

    return this.checkPromise(promise);
  }

  loadGroupBy(parameters: Object): ResponsePromise {
    const promise = this.client.get(
      API_GROUP_DECLARANTS,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  updateFieldsInCustomGroup(
    groupId: unknown,
    attributes: Object
  ): ResponsePromise {
    const promise = this.client.put(
      API_UPDATE_GROUP_DECLARANTS(groupId),
      attributes
    );

    return this.checkPromise(promise);
  }

  operateCash(parameters: IObjectMap): ResponsePromise {
    const promise = this.client.post(API_CASHBOX_OPERATE, parameters);

    return this.checkPromise(promise);
  }

  getLastEncashmentAction(departmentId: unknown): ResponsePromise {
    return this.client.get(API_LAST_ENCASHMENT_ACTION(departmentId));
  }

  loadCashboxItems(declarantId: unknown, parameters: Object): ResponsePromise {
    const promise = this.client.get(
      LOAD_CASHBOX_DATA_BY_DECLARANT(declarantId),
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  getLatestDepartmentDates(): ResponsePromise {
    const promise = this.client.get(GET_LATEST_DEPARTMENT_DATES);

    return this.checkPromise(promise);
  }

  createCmr(params: Object): ResponsePromise {
    const promise = this.client.post(
      API_CREATE_CMR,
      createCmrNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  updateCmr(id: unknown, params: Object): ResponsePromise {
    const promise = this.client.put(
      API_UPDATE_CMR(id),
      createCmrNormaliser(params)
    );

    return this.checkPromise(promise);
  }

  getCmr(id: unknown): ResponsePromise {
    const promise = this.client.get(API_GET_CMR(id));

    return this.checkPromise(promise);
  }

  getCountries(): ResponsePromise {
    const promise = this.client.get(API_GET_COUNTRIES);

    return this.checkPromise(promise);
  }

  getServices(): ResponsePromise {
    const promise = this.client.get(API_GET_SERVICES);

    return this.checkPromise(promise);
  }

  attachDeclarantToCustomEntities(
    customGroupId: unknown,
    declarants: Declarant[]
  ): ResponsePromise {
    const promise = this.client.put(
      ATTACH_DECLARANT_TO_CUSTOM_GROUP(customGroupId),
      {
        declarants: declarants.map((entity) => entity.id),
      }
    );

    return this.checkPromise(promise);
  }

  getCmrs(parameters: Object): ResponsePromise {
    const promise = this.client.get(
      CMR_LIST,
      normalize(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  deleteCmr(id: number): ResponsePromise {
    const promise = this.client.delete(DELETE_CMR(id));

    return this.checkPromise(promise);
  }

  downloadCmrsPdf(id: number): ResponsePromise {
    const promise = this.client.get(DOWNLOAD_CMRS_PDF(id));

    return this.checkPromise(promise);
  }

  downloadExcelFile(parameters: Object): ResponsePromise {
    const promise = this.client.post(
      DOWNLOAD_EXCEL_FILE,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  downloadCustomExcelFile(parameters: Object): ResponsePromise {
    const promise = this.client.post(
      API_DOWNLOAD_CUSTOM_EXCEL_FILE_URL,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  getCmrNumber(): ResponsePromise {
    const promise = this.client.get(GET_CMR_NUMBER);

    return this.checkPromise(promise);
  }

  copyToNew(id: number): ResponsePromise {
    const promise = this.client.post(COPY_TO_NEW_CMR(id));

    return this.checkPromise(promise);
  }

  cmrAutocomplete(
    fieldName: string,
    value: string | number,
    options?: Object
  ): ResponsePromise {
    const promise = this.client.get(
      API_AUTOCOMPLETE_CMR,
      {
        name: fieldName,
        value,
      },
      options
    );

    return this.checkPromise(promise);
  }

  updateCustomGroupField(id: unknown, params: Object): ResponsePromise {
    const promise = this.client.put(
      API_UPDATE_CUSTOM_GROUP_ATTRIBUTES(id),
      params
    );

    return this.checkPromise(promise);
  }

  loadLogisticByClients(parameters?: Object): ResponsePromise {
    const promise = this.client.get(
      API_GET_LOGISTIC_LIST,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  loadFleetExpensesByClients(parameters?: IObjectMap): ResponsePromise {
    const promise: Promise<Response> = this.client.get(
      API_FLEET_EXPENSE,
      parameters
    );
    return this.checkPromise(promise);
  }

  loadFleetExpensesTransports(parameters?: IObjectMap): ResponsePromise {
    const promise: Promise<Response> = this.client.get(
      API_GET_FLEET_EXPENSES_TRANSPORTS,
      parameters
    );

    return this.checkPromise(promise);
  }

  createFleetExpensesTransport(
    params: CreateFleetExpensesTransportParameters
  ): ResponsePromise {
    const promise: Promise<Response> = this.client.post(
      API_GET_FLEET_EXPENSES_TRANSPORTS,
      params
    );

    return this.checkPromise(promise);
  }

  loadFleetExpensesSpendingTypes(parameters?: IObjectMap): ResponsePromise {
    const promise: Promise<Response> = this.client.get(
      API_GET_FLEET_EXPENSES_SPENDING_TYPES,
      parameters
    );

    return this.checkPromise(promise);
  }

  loadFleetDrivers(): ResponsePromise {
    const promise: Promise<Response> = this.client.get(API_GET_FLEET_DRIVERS);

    return this.checkPromise(promise);
  }

  loadFleetDriverCardAssignments(
    driverId: FleetDriver["id"],
    date: string
  ): ResponsePromise {
    const promise: Promise<Response> = this.client.get(
      API_GET_FLEET_DRIVER_CARD_ASSIGNMENTS(driverId),
      { date }
    );

    return this.checkPromise(promise);
  }

  createFleetExpense(params: FleetExpenseParameters): ResponsePromise {
    const promise: Promise<Response> = this.client.post(
      API_FLEET_EXPENSE,
      params
    );

    return this.checkPromise(promise);
  }

  updateFleetExpense(
    id: FleetExpenseId,
    params: FleetExpenseParameters
  ): ResponsePromise {
    const promise: Promise<Response> = this.client.put(
      `${API_FLEET_EXPENSE}/${id}`,
      params
    );

    return this.checkPromise(promise);
  }

  deleteFleetExpense(id: FleetExpenseId): ResponsePromise {
    const promise: Promise<Response> = this.client.delete(
      `${API_FLEET_EXPENSE}/${id}`
    );

    return this.checkPromise(promise);
  }

  saveLogisticEntity(parameters?: Object): ResponsePromise {
    const promise = this.client.post(API_SAVE_LOGISTIC_ENTITY, parameters);

    return this.checkPromise(promise);
  }

  updateLogisticEntity(id: unknown, params: Object): ResponsePromise {
    const promise = this.client.put(API_UPDATE_LOGISTIC_ENTITY(id), params);

    return this.checkPromise(promise);
  }

  deleteLogisticEntity(id: unknown): ResponsePromise {
    const promise = this.client.delete(API_DELETE_LOGISTIC_ENTITY(id));

    return this.checkPromise(promise);
  }

  getSearchFieldValues(field: string): ResponsePromise {
    const promise = this.client.get(GET_SEARCH_FIELD_VALUES(field));

    return this.checkPromise(promise);
  }

  saveLogisticDocuments(formData: FormData): ResponsePromise {
    this.defaultHeaders.delete("Content-Type");

    const promise = this.client.post(API_SAVE_LOGISTIC_DOCUMENTS, formData);

    this.defaultHeaders.append("Content-Type", "application/json");

    return this.checkPromise(promise);
  }

  downloadFile(parameters?: Record<string, unknown>): ResponsePromise {
    this.defaultHeaders.delete("Content-Type");

    const promise = this.client.get(API_DOWNLOAD_LOGISTIC_DOCUMENT, parameters);

    this.defaultHeaders.append("Content-Type", "application/json");

    return this.checkPromise(promise);
  }

  deleteLogisticFile(parameters?: DownloadFileParameters): ResponsePromise {
    const promise = this.client.put(
      API_DELETE_LOGISTIC_DOCUMENT(parameters?.id),
      { documents: parameters?.documents }
    );

    return this.checkPromise(promise);
  }

  downloadDeclarantAsExcelFile(parameters: Object): ResponsePromise {
    const promise = this.client.post(
      DOWNLOAD_DECLARANT_TABLE_DATA_AS_EXCEL_FILE,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  downloadLogisticAsExcelFile(parameters: Object): ResponsePromise {
    const promise = this.client.post(
      DOWNLOAD_LOGISTIC_TABLE_DATA_AS_EXCEL_FILE,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  // Contracts
  deleteContractsEntity(id: unknown): ResponsePromise {
    const promise = this.client.delete(API_DELETE_CONTRACTS_ENTITY(id));

    return this.checkPromise(promise);
  }

  saveContractsEntity(parameters?: Object): ResponsePromise {
    const promise = this.client.post(API_SAVE_CONTRACTS_ENTITY, parameters);

    return this.checkPromise(promise);
  }

  saveContractsDocuments(formData: FormData): ResponsePromise {
    this.defaultHeaders.delete("Content-Type");

    const promise = this.client.post(API_SAVE_CONTRACTS_DOCUMENTS, formData);

    this.defaultHeaders.append("Content-Type", "application/json");

    return this.checkPromise(promise);
  }

  updateContractsEntity(id: unknown, params: Object): ResponsePromise {
    const promise = this.client.put(API_UPDATE_CONTRACTS_ENTITY(id), params);

    return this.checkPromise(promise);
  }

  downloadContractsFile(parameters?: Record<string, unknown>): ResponsePromise {
    this.defaultHeaders.delete("Content-Type");

    const promise = this.client.get(
      API_DOWNLOAD_CONTRACTS_DOCUMENT,
      parameters
    );

    this.defaultHeaders.append("Content-Type", "application/json");

    return this.checkPromise(promise);
  }

  deleteContractsFile(parameters?: DownloadFileParameters): ResponsePromise {
    const promise = this.client.put(
      API_DELETE_CONTRACTS_DOCUMENT(parameters?.id),
      { documents: parameters?.documents }
    );

    return this.checkPromise(promise);
  }

  loadContractsByClients(parameters?: Object): ResponsePromise {
    const promise = this.client.get(
      API_GET_CONTRACTS_LIST,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  getContractsSearchFieldValues(field: string): ResponsePromise {
    const promise = this.client.get(GET_CONTRACTS_SEARCH_FIELD_VALUES(field));

    return this.checkPromise(promise);
  }

  downloadContractsAsExcelFile(parameters: Object): ResponsePromise {
    const promise = this.client.post(
      DOWNLOAD_CONTRACTS_TABLE_DATA_AS_EXCEL_FILE,
      loadDeclarantsNormaliser(parameters as Parameters)
    );

    return this.checkPromise(promise);
  }

  getStatusOptions(): ResponsePromise {
    const promise = this.client.get(STATUS_OPTIONS);

    return this.checkPromise(promise);
  }

  generateInvoice(parameters: Object): ResponsePromise {
    const promise = this.client.post(API_DECLARANTS_INVOICE, parameters);

    return this.checkPromise(promise);
  }

  generateRegisterOfAccounts(payload: {
    date_from: string;
    date_to: string;
    groups: object[];
  }): ResponsePromise {
    const promise: Promise<Response> = this.client.post(
      API_DECLARANTS_REGISTER_OF_ACCOUNTS,
      payload
    );

    return this.checkPromise(promise);
  }

  downloadInvoice(key: number, type?: string): ResponsePromise {
    const url = `${API_DECLARANTS_INVOICE}/${key}/download${
      type ? `?type=${encodeURIComponent(type)}` : ""
    }`;
    const promise: Promise<Response> = this.client.get(url);

    return this.checkPromise(promise);
  }
}

export default new Manager();
